import { gql } from '@apollo/client';

export default gql`
  query LatestAppBuildHistory($date: Datetime!) {
    allAppBuildHistories(
      orderBy: CREATED_AT_DESC
      first: 1
      filter: { createdAt: { lessThanOrEqualTo: $date } }
    ) {
      nodes {
        build
        appDisplayVersion
        createdAt
      }
    }
  }
`;
